export function Brush01Icon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1482_584)">
        <path
          d="M7.49982 9.35183L10.648 12.5M6.64554 17.479C5.50651 18.6181 3.33317 18.3333 1.6665 18.3333C2.52075 16.6666 1.38172 14.4933 2.52075 13.3543C3.65978 12.2152 5.50651 12.2152 6.64554 13.3543C7.78457 14.4933 7.78457 16.34 6.64554 17.479ZM9.9345 13.2705L17.5488 5.0471C18.2194 4.32279 18.1978 3.19797 17.4998 2.49998C16.8018 1.80199 15.677 1.78036 14.9527 2.45101L6.72928 10.0653C6.30434 10.4587 6.09186 10.6555 5.96794 10.8653C5.67079 11.3684 5.65883 11.9904 5.93643 12.5046C6.05219 12.719 6.25695 12.9238 6.66646 13.3333C7.07597 13.7428 7.28072 13.9476 7.49515 14.0633C8.00934 14.3409 8.63135 14.329 9.13448 14.0318C9.3443 13.9079 9.54104 13.6954 9.9345 13.2705Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1482_584">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
